import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export function EpicRedirect(): JSX.Element {
  const history = useHistory();

  const parseUrl = (): string => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    return code;
  };

  useEffect(() => {
    if (!window.opener) {
      history.push('/account');
    }

    const epicData = parseUrl();

    if (epicData) {
      window.opener.postMessage({ epicData }, '*');
    }

    window.close();
  }, []);

  return (
    <div className='container'>
      <div className='auth-container'>
        <div className='auth-card'>
          <div className='row'>
            <div className='col text-center'>
              <p>Redirect...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
